import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    // 1. Controlliamo se è attiva la paginazione classica
    const isClassic = this.hasAttribute('data-classic-pagination');

    if (isClassic) {
      // Trucco: Svuotiamo temporaneamente i riferimenti agli elementi che attivano lo scroll automatico
      // in modo che il metodo super.connectedCallback() non trovi né viewMorePrevious né viewMoreNext
      const originalRefs = { ...this.refs };
      if (this.refs) {
        delete this.refs.viewMorePrevious;
        delete this.refs.viewMoreNext;
      }

      // Eseguiamo l'inizializzazione genitore (eviterà di attivare l'IntersectionObserver)
      super.connectedCallback();

      // Ripristiniamo le refs originali per non rompere altre logiche del tema
      this.refs = { ...this.refs, ...originalRefs };

      // Forziamo la disconnessione immediata dell'observer qualora si fosse attivato
      if (this.infinityScrollObserver) {
        this.infinityScrollObserver.disconnect();
      }
    } else {
      // Comportamento AJAX standard del tema
      super.connectedCallback();
    }

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');

    // 2. INTERCETTIAMO I CLICK SUI NUMERI DI PAGINA CLASSICI
    this.addEventListener('click', (event) => {
      const link = event.target.closest('.pagination-classic a');
      if (link && link.href) {
        // Blocca la propagazione verso l'alto impedendo qualsiasi cattura AJAX residua
        event.stopPropagation();
        // Forza il ricaricamento nativo del browser
        window.location.href = link.href;
      }
    });
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
    if (typeof super.disconnectedCallback === 'function') {
      super.disconnectedCallback();
    }
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}


// import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
// import PaginatedList from '@theme/paginated-list';

// /**
//  * A custom element that renders a pagniated results list
//  */
// export default class ResultsList extends PaginatedList {
//   connectedCallback() {
//     super.connectedCallback();

//     mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
//     this.setAttribute('initialized', '');
//   }

//   disconnectedCallback() {
//     mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
//   }

//   /**
//    * Updates the layout.
//    *
//    * @param {Event} event
//    */
//   updateLayout({ target }) {
//     if (!(target instanceof HTMLInputElement)) return;

//     this.#animateLayoutChange(target.value);
//   }

//   /**
//    * Sets the layout.
//    *
//    * @param {string} value
//    */
//   #animateLayoutChange = async (value) => {
//     const { grid } = this.refs;

//     if (!grid) return;

//     await startViewTransition(() => this.#setLayout(value), ['product-grid']);

//     requestIdleCallback(() => {
//       const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
//       sessionStorage.setItem(`product-grid-view-${viewport}`, value);
//     });
//   };

//   /**
//    * Animates the layout change.
//    *
//    * @param {string} value
//    */
//   #setLayout(value) {
//     const { grid } = this.refs;
//     if (!grid) return;
//     grid.setAttribute('product-grid-view', value);
//   }

//   /**
//    * Handles the media query change event.
//    *
//    * @param {MediaQueryListEvent} event
//    */
//   #handleMediaQueryChange = (event) => {
//     const targetElement = event.matches
//       ? this.querySelector('[data-grid-layout="desktop-default-option"]')
//       : this.querySelector('[data-grid-layout="mobile-option"]');

//     if (!(targetElement instanceof HTMLInputElement)) return;

//     targetElement.checked = true;
//     this.#setLayout('default');
//   };
// }

// if (!customElements.get('results-list')) {
//   customElements.define('results-list', ResultsList);
// }
